import { api } from './client';

export const orientationApi = {
  /**
   * Read-only "state of the story" — phase, signals, spine, open threads,
   * last-worked. All derived server-side; nothing persists.
   */
  get: (storyId) => api.get(`/stories/${storyId}/orientation`),
};

export default orientationApi;
